import Stripe from 'stripe';
import { Currency } from '../../entities/Currency';

export interface TaxId {
  type: Exclude<Stripe.TaxId.Type, 'unknown'>;
  label: string;
  placeholder: string;
}

export interface Country {
  label: string;
  value: string;
  taxIds: TaxId[];
  currency: Currency | null;
}

export const countriesList: Country[] = [{
  label: 'Albania',
  value: 'AL',
  taxIds: [{
    type: 'al_tin',
    label: 'Albania TIN',
    placeholder: 'J12345678N'
  }],
  currency: 'ALL'
}, {
  label: 'Åland Islands',
  value: 'AX',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Algeria',
  value: 'DZ',
  taxIds: [],
  currency: 'DZD'
}, {
  label: 'American Samoa',
  value: 'AS',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Andorra',
  value: 'AD',
  taxIds: [
    {
      type: 'ad_nrt',
      label: 'Andorran NRT number',
      placeholder: 'A-123456-Z'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Angola',
  value: 'AO',
  taxIds: [
    {
      type: 'ao_tin',
      label: 'Angola Tax Identification Number',
      placeholder: '5123456789'
    }
  ],
  currency: 'AOA'
}, {
  label: 'Anguilla',
  value: 'AI',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Antarctica',
  value: 'AQ',
  taxIds: [],
  currency: null
}, {
  label: 'Antigua and Barbuda',
  value: 'AG',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Argentina',
  value: 'AR',
  taxIds: [
    {
      type: 'ar_cuit',
      label: 'Argentinian tax ID number',
      placeholder: '12-3456789-01'
    }
  ],
  currency: 'ARS'
}, {
  label: 'Armenia',
  value: 'AM',
  taxIds: [
    {
      type: 'am_tin',
      label: 'Armenia Tax Identification Number',
      placeholder: '02538904'
    }
  ],
  currency: 'AMD'
}, {
  label: 'Aruba',
  value: 'AW',
  taxIds: [],
  currency: 'AWG'
}, {
  label: 'Australia',
  value: 'AU',
  taxIds: [
    {
      type: 'au_abn',
      label: 'Australian Business Number',
      placeholder: '12345678912'
    },
    {
      type: 'au_arn',
      label: 'Australian Taxation Office Reference Number',
      placeholder: '123456789123'
    }
  ],
  currency: 'AUD'
}, {
  label: 'Austria',
  value: 'AT',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'ATU12345678'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Azerbaijan',
  value: 'AZ',
  taxIds: [],
  currency: 'AZN'
}, {
  label: 'Bahamas',
  value: 'BS',
  taxIds: [
    {
      type: 'bs_tin',
      label: 'Bahamas Tax Identification Number',
      placeholder: '123.456.789'
    }
  ],
  currency: 'BSD'
}, {
  label: 'Bahrain',
  value: 'BH',
  taxIds: [
    {
      type: 'bh_vat',
      label: 'Bahraini VAT Number',
      placeholder: '123456789012345'
    }
  ],
  currency: 'BHD'
}, {
  label: 'Bangladesh',
  value: 'BD',
  taxIds: [],
  currency: 'BDT'
}, {
  label: 'Barbados',
  value: 'BB',
  taxIds: [
    {
      type: 'bb_tin',
      label: 'Barbados Tax Identification Number',
      placeholder: '1123456789012'
    }
  ],
  currency: 'BBD'
}, {
  label: 'Belarus',
  value: 'BY',
  taxIds: [
    {
      type: 'by_tin',
      label: 'Belarus TIN Number',
      placeholder: '123456789'
    }
  ],
  currency: 'BYN'
}, {
  label: 'Belgium',
  value: 'BE',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'BE0123456789'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Belize',
  value: 'BZ',
  taxIds: [],
  currency: 'BZD'
}, {
  label: 'Benin',
  value: 'BJ',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Bermuda',
  value: 'BM',
  taxIds: [],
  currency: 'BMD'
}, {
  label: 'Bhutan',
  value: 'BT',
  taxIds: [],
  currency: 'BTN'
}, {
  label: 'Bolivia',
  value: 'BO',
  taxIds: [
    {
      type: 'bo_tin',
      label: 'Bolivian tax ID',
      placeholder: '123456789'
    }
  ],
  currency: 'BOB'
}, {
  label: 'Bonaire, Sint Eustatius and Saba',
  value: 'BQ',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Bosnia and Herzegovina',
  value: 'BA',
  taxIds: [
    {
      type: 'ba_tin',
      label: 'Bosnia and Herzegovina Tax Identification Number',
      placeholder: '123456789012'
    }
  ],
  currency: 'BAM'
}, {
  label: 'Botswana',
  value: 'BW',
  taxIds: [],
  currency: 'BWP'
}, {
  label: 'Bouvet Island',
  value: 'BV',
  taxIds: [],
  currency: null
}, {
  label: 'Brazil',
  value: 'BR',
  taxIds: [
    {
      type: 'br_cnpj',
      label: 'Brazilian CNPJ number',
      placeholder: '01.234.456/5432-10'
    },
    {
      type: 'br_cpf',
      label: 'Brazilian CPF number',
      placeholder: '123.456.789-87'
    }
  ],
  currency: 'BRL'
}, {
  label: 'British Indian Ocean Territory',
  value: 'IO',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Brunei Darussalam',
  value: 'BN',
  taxIds: [],
  currency: 'BND'
}, {
  label: 'Bulgaria',
  value: 'BG',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'BG0123456789'
    }
  ],
  currency: 'BGN'
}, {
  label: 'Burkina Faso',
  value: 'BF',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Burundi',
  value: 'BI',
  taxIds: [],
  currency: 'BIF'
}, {
  label: 'Cabo Verde',
  value: 'CV',
  taxIds: [],
  currency: 'CVE'
}, {
  label: 'Cambodia',
  value: 'KH',
  taxIds: [
    {
      type: 'kh_tin',
      label: 'Cambodia Tax Identification Number',
      placeholder: '1001-123456789'
    }
  ],
  currency: 'KHR'
}, {
  label: 'Cameroon',
  value: 'CM',
  taxIds: [],
  currency: 'XAF'
}, {
  label: 'Canada',
  value: 'CA',
  taxIds: [
    {
      type: 'ca_bn',
      label: 'Canadian BN',
      placeholder: '123456789'
    },
    {
      type: 'ca_gst_hst',
      label: 'Canadian GST/HST number',
      placeholder: '123456789RT0002'
    },
    {
      type: 'ca_pst_bc',
      label: 'Canadian PST number (British Columbia)',
      placeholder: 'PST-1234-5678'
    },
    {
      type: 'ca_pst_mb',
      label: 'Canadian PST number (Manitoba)',
      placeholder: '123456-7'
    },
    {
      type: 'ca_pst_sk',
      label: 'Canadian PST number (Saskatchewan)',
      placeholder: '1234567'
    },
    {
      type: 'ca_qst',
      label: 'Canadian QST number (Québec)',
      placeholder: '1234567890TQ1234'
    }
  ],
  currency: 'CAD'
}, {
  label: 'Cayman Islands',
  value: 'KY',
  taxIds: [],
  currency: 'KYD'
}, {
  label: 'Central African Republic',
  value: 'CF',
  taxIds: [],
  currency: 'XAF'
}, {
  label: 'Chad',
  value: 'TD',
  taxIds: [],
  currency: 'XAF'
}, {
  label: 'Chile',
  value: 'CL',
  taxIds: [
    {
      type: 'cl_tin',
      label: 'Chilean TIN',
      placeholder: '12.345.678-K'
    }
  ],
  currency: 'CLP'
}, {
  label: 'China',
  value: 'CN',
  taxIds: [
    {
      type: 'cn_tin',
      label: 'Chinese tax ID',
      placeholder: '123456789012345678'
    }
  ],
  currency: 'CNY'
}, {
  label: 'Christmas Island',
  value: 'CX',
  taxIds: [],
  currency: 'AUD'
}, {
  label: 'Colombia',
  value: 'CO',
  taxIds: [
    {
      type: 'co_nit',
      label: 'Colombian NIT number',
      placeholder: '123.456.789-0'
    }
  ],
  currency: 'COP'
}, {
  label: 'Comoros',
  value: 'KM',
  taxIds: [],
  currency: 'KMF'
}, {
  label: 'Congo',
  value: 'CD',
  taxIds: [
    {
      type: 'cd_nif',
      label: 'Congo Tax Identification Number',
      placeholder: 'A0123456M'
    }
  ],
  currency: 'CDF'
}, {
  label: 'Congo',
  value: 'CG',
  taxIds: [],
  currency: 'XAF'
}, {
  label: 'Cook Islands',
  value: 'CK',
  taxIds: [],
  currency: 'NZD'
}, {
  label: 'Costa Rica',
  value: 'CR',
  taxIds: [
    {
      type: 'cr_tin',
      label: 'Costa Rican tax ID',
      placeholder: '1-234-567890'
    }
  ],
  currency: 'CRC'
}, {
  label: 'Croatia',
  value: 'HR',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'HR12345678912'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Cuba',
  value: 'CU',
  taxIds: [],
  currency: 'CUC'
}, {
  label: 'Curaçao',
  value: 'CW',
  taxIds: [],
  currency: 'ANG'
}, {
  label: 'Cyprus',
  value: 'CY',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'CY12345678Z'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Czechia',
  value: 'CZ',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'CZ1234567890'
    }
  ],
  currency: 'CZK'
}, {
  label: 'Côte d\'Ivoire',
  value: 'CI',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Denmark',
  value: 'DK',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'DK12345678'
    }
  ],
  currency: 'DKK'
}, {
  label: 'Djibouti',
  value: 'DJ',
  taxIds: [],
  currency: 'DJF'
}, {
  label: 'Dominica',
  value: 'DM',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Dominican Republic',
  value: 'DO',
  taxIds: [
    {
      type: 'do_rcn',
      label: 'Dominican RCN number',
      placeholder: '123-4567890-1'
    }
  ],
  currency: 'DOP'
}, {
  label: 'Ecuador',
  value: 'EC',
  taxIds: [
    {
      type: 'ec_ruc',
      label: 'Ecuadorian RUC number',
      placeholder: '1234567890001'
    }
  ],
  currency: 'USD'
}, {
  label: 'Egypt',
  value: 'EG',
  taxIds: [
    {
      type: 'eg_tin',
      label: 'Egyptian Tax Identification Number',
      placeholder: '123456789'
    }
  ],
  currency: 'EGP'
}, {
  label: 'El Salvador',
  value: 'SV',
  taxIds: [
    {
      type: 'sv_nit',
      label: 'El Salvadorian NIT number',
      placeholder: '1234-567890-123-4'
    }
  ],
  currency: 'USD'
}, {
  label: 'Equatorial Guinea',
  value: 'GQ',
  taxIds: [],
  currency: 'XAF'
}, {
  label: 'Eritrea',
  value: 'ER',
  taxIds: [],
  currency: 'ERN'
}, {
  label: 'Estonia',
  value: 'EE',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'EE123456789'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Eswatini',
  value: 'SZ',
  taxIds: [],
  currency: 'SZL'
}, {
  label: 'Ethiopia',
  value: 'ET',
  taxIds: [],
  currency: 'ETB'
}, {
  label: 'Faroe Islands',
  value: 'FO',
  taxIds: [],
  currency: 'DKK'
}, {
  label: 'Fiji',
  value: 'FJ',
  taxIds: [],
  currency: 'FJD'
}, {
  label: 'Finland',
  value: 'FI',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'FI12345678'
    }
  ],
  currency: 'EUR'
}, {
  label: 'France',
  value: 'FR',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'FRAB123456789'
    }
  ],
  currency: 'EUR'
}, {
  label: 'French Guiana',
  value: 'GF',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'French Polynesia',
  value: 'PF',
  taxIds: [],
  currency: 'XPF'
}, {
  label: 'Gabon',
  value: 'GA',
  taxIds: [],
  currency: 'XAF'
}, {
  label: 'Gambia',
  value: 'GM',
  taxIds: [],
  currency: 'GMD'
}, {
  label: 'Georgia',
  value: 'GE',
  taxIds: [
    {
      type: 'ge_vat',
      label: 'Georgian VAT',
      placeholder: '123456789'
    }
  ],
  currency: 'GEL'
}, {
  label: 'Germany',
  value: 'DE',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'DE123456789'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Ghana',
  value: 'GH',
  taxIds: [],
  currency: 'GHS'
}, {
  label: 'Gibraltar',
  value: 'GI',
  taxIds: [],
  currency: 'GIP'
}, {
  label: 'Greece',
  value: 'GR',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'EL123456789'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Greenland',
  value: 'GL',
  taxIds: [],
  currency: 'DKK'
}, {
  label: 'Grenada',
  value: 'GD',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Guadeloupe',
  value: 'GP',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Guam',
  value: 'GU',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Guatemala',
  value: 'GT',
  taxIds: [],
  currency: 'GTQ'
}, {
  label: 'Guernsey',
  value: 'GG',
  taxIds: [],
  currency: 'GBP'
}, {
  label: 'Guinea',
  value: 'GN',
  taxIds: [
    {
      type: 'gn_nif',
      label: 'Guinea Tax Identification Number',
      placeholder: '123456789'
    }
  ],
  currency: 'GNF'
}, {
  label: 'Guinea-Bissau',
  value: 'GW',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Guyana',
  value: 'GY',
  taxIds: [],
  currency: 'GYD'
}, {
  label: 'Haiti',
  value: 'HT',
  taxIds: [],
  currency: 'HTG'
}, {
  label: 'Holy See',
  value: 'VA',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Honduras',
  value: 'HN',
  taxIds: [],
  currency: 'HNL'
}, {
  label: 'Hong Kong',
  value: 'HK',
  taxIds: [
    {
      type: 'hk_br',
      label: 'Hong Kong BR number',
      placeholder: '12345678'
    }
  ],
  currency: 'HKD'
}, {
  label: 'Hungary',
  value: 'HU',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'HU12345678'
    }
  ],
  currency: 'HUF'
}, {
  label: 'Iceland',
  value: 'IS',
  taxIds: [
    {
      type: 'is_vat',
      label: 'Icelandic VAT',
      placeholder: '123456'
    }
  ],
  currency: 'ISK'
}, {
  label: 'India',
  value: 'IN',
  taxIds: [
    {
      type: 'in_gst',
      label: 'Indian GST number',
      placeholder: '12ABCDE3456FGZH'
    }
  ],
  currency: 'INR'
}, {
  label: 'Indonesia',
  value: 'ID',
  taxIds: [
    {
      type: 'id_npwp',
      label: 'Indonesian NPWP number',
      placeholder: '012.345.678.9-012.345'
    }
  ],
  currency: 'IDR'
}, {
  label: 'Iran',
  value: 'IR',
  taxIds: [],
  currency: 'IRR'
}, {
  label: 'Iraq',
  value: 'IQ',
  taxIds: [],
  currency: 'IQD'
}, {
  label: 'Ireland',
  value: 'IE',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'IE1234567AB'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Isle of Man',
  value: 'IM',
  taxIds: [],
  currency: 'GBP'
}, {
  label: 'Israel',
  value: 'IL',
  taxIds: [
    {
      type: 'il_vat',
      label: 'Israel VAT',
      placeholder: '000012345'
    }
  ],
  currency: 'ILS'
}, {
  label: 'Italy',
  value: 'IT',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'IT12345678912'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Jamaica',
  value: 'JM',
  taxIds: [],
  currency: 'JMD'
}, {
  label: 'Japan',
  value: 'JP',
  taxIds: [
    {
      type: 'jp_cn',
      label: 'Japanese Corporate Number',
      placeholder: '1234567891234'
    },
    {
      type: 'jp_rn',
      label: 'Japanese Registered Foreign Businesses',
      placeholder: '12345'
    },
    {
      type: 'jp_trn',
      label: 'Japanese Tax Registration Number',
      placeholder: 'T1234567891234'
    }
  ],
  currency: 'JPY'
}, {
  label: 'Jersey',
  value: 'JE',
  taxIds: [],
  currency: 'GBP'
}, {
  label: 'Jordan',
  value: 'JO',
  taxIds: [],
  currency: 'JOD'
}, {
  label: 'Kazakhstan',
  value: 'KZ',
  taxIds: [
    {
      type: 'kz_bin',
      label: 'Kazakhstani Business Identification Number',
      placeholder: '123456789012'
    }
  ],
  currency: 'KZT'
}, {
  label: 'Kenya',
  value: 'KE',
  taxIds: [
    {
      type: 'ke_pin',
      label: 'Kenya Revenue Authority Personal Identification Number',
      placeholder: 'P000111111A'
    }
  ],
  currency: 'KES'
}, {
  label: 'Kiribati',
  value: 'KI',
  taxIds: [],
  currency: 'AUD'
}, {
  label: 'Korea',
  value: 'KR',
  taxIds: [
    {
      type: 'kr_brn',
      label: 'Korean BRN',
      placeholder: '123-45-67890'
    }
  ],
  currency: 'KRW'
}, {
  label: 'Kuwait',
  value: 'KW',
  taxIds: [],
  currency: 'KWD'
}, {
  label: 'Kyrgyzstan',
  value: 'KG',
  taxIds: [],
  currency: 'KGS'
}, {
  label: 'Latvia',
  value: 'LV',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'LV12345678912'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Lebanon',
  value: 'LB',
  taxIds: [],
  currency: 'LBP'
}, {
  label: 'Lesotho',
  value: 'LS',
  taxIds: [],
  currency: 'LSL'
}, {
  label: 'Liberia',
  value: 'LR',
  taxIds: [],
  currency: 'LRD'
}, {
  label: 'Libya',
  value: 'LY',
  taxIds: [],
  currency: 'LYD'
}, {
  label: 'Liechtenstein',
  value: 'LI',
  taxIds: [
    {
      type: 'li_uid',
      label: 'Liechtensteinian UID number',
      placeholder: 'CHE123456789'
    },
    {
      type: 'li_vat',
      label: 'Liechtensteinian VAT number',
      placeholder: '12345'
    }
  ],
  currency: 'CHF'
}, {
  label: 'Lithuania',
  value: 'LT',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'LT123456789123'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Luxembourg',
  value: 'LU',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'LU12345678'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Macao',
  value: 'MO',
  taxIds: [],
  currency: 'MOP'
}, {
  label: 'Madagascar',
  value: 'MG',
  taxIds: [],
  currency: 'MGA'
}, {
  label: 'Malawi',
  value: 'MW',
  taxIds: [],
  currency: 'MWK'
}, {
  label: 'Malaysia',
  value: 'MY',
  taxIds: [
    {
      type: 'my_frp',
      label: 'Malaysian FRP number',
      placeholder: '12345678'
    },
    {
      type: 'my_itn',
      label: 'Malaysian ITN',
      placeholder: 'C 1234567890'
    },
    {
      type: 'my_sst',
      label: 'Malaysian SST number',
      placeholder: 'A12-3456-78912345'
    }
  ],
  currency: 'MYR'
}, {
  label: 'Maldives',
  value: 'MV',
  taxIds: [],
  currency: 'MVR'
}, {
  label: 'Mali',
  value: 'ML',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Malta',
  value: 'MT',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'MT12345678'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Marshall Islands',
  value: 'MH',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Martinique',
  value: 'MQ',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Mauritania',
  value: 'MR',
  taxIds: [
    {
      type: 'mr_nif',
      label: 'Mauritania Tax Identification Number',
      placeholder: '12345678'
    }
  ],
  currency: 'MRU'
}, {
  label: 'Mauritius',
  value: 'MU',
  taxIds: [],
  currency: 'MUR'
}, {
  label: 'Mayotte',
  value: 'YT',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Mexico',
  value: 'MX',
  taxIds: [
    {
      type: 'mx_rfc',
      label: 'Mexican RFC number',
      placeholder: 'ABC010203AB9'
    }
  ],
  currency: 'MXN'
}, {
  label: 'Moldova',
  value: 'MD',
  taxIds: [
    {
      type: 'md_vat',
      label: 'Moldova VAT Number',
      placeholder: '1234567'
    }
  ],
  currency: 'MDL'
}, {
  label: 'Monaco',
  value: 'MC',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Mongolia',
  value: 'MN',
  taxIds: [],
  currency: 'MNT'
}, {
  label: 'Montenegro',
  value: 'ME',
  taxIds: [
    {
      type: 'me_pib',
      label: 'Montenegro PIB Number',
      placeholder: '12345678'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Montserrat',
  value: 'MS',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Morocco',
  value: 'MA',
  taxIds: [
    {
      type: 'ma_vat',
      label: 'Morocco VAT Number',
      placeholder: '12345678'
    }
  ],
  currency: 'MAD'
}, {
  label: 'Mozambique',
  value: 'MZ',
  taxIds: [],
  currency: 'MZN'
}, {
  label: 'Myanmar',
  value: 'MM',
  taxIds: [],
  currency: 'MMK'
}, {
  label: 'Namibia',
  value: 'NA',
  taxIds: [],
  currency: 'NAD'
}, {
  label: 'Nauru',
  value: 'NR',
  taxIds: [],
  currency: 'AUD'
}, {
  label: 'Nepal',
  value: 'NP',
  taxIds: [
    {
      type: 'np_pan',
      label: 'Nepal PAN Number',
      placeholder: '123456789'
    }
  ],
  currency: 'NPR'
}, {
  label: 'Netherlands',
  value: 'NL',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'NL123456789B12'
    }
  ],
  currency: 'EUR'
}, {
  label: 'New Caledonia',
  value: 'NC',
  taxIds: [],
  currency: 'XPF'
}, {
  label: 'New Zealand',
  value: 'NZ',
  taxIds: [
    {
      type: 'nz_gst',
      label: 'New Zealand GST number',
      placeholder: '123456789'
    }
  ],
  currency: 'NZD'
}, {
  label: 'Nicaragua',
  value: 'NI',
  taxIds: [],
  currency: 'NIO'
}, {
  label: 'Niger',
  value: 'NE',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Nigeria',
  value: 'NG',
  taxIds: [
    {
      type: 'ng_tin',
      label: 'Nigerian Tax Identification Number',
      placeholder: '12345678-0001'
    }
  ],
  currency: 'NGN'
}, {
  label: 'Niue',
  value: 'NU',
  taxIds: [],
  currency: 'NZD'
}, {
  label: 'Norfolk Island',
  value: 'NF',
  taxIds: [],
  currency: 'AUD'
}, {
  label: 'Norway',
  value: 'NO',
  taxIds: [
    {
      type: 'no_vat',
      label: 'Norwegian VAT number',
      placeholder: '123456789MVA'
    },
    {
      type: 'no_voec',
      label: 'Norwegian VAT on e-commerce number',
      placeholder: '1234567'
    }
  ],
  currency: 'NOK'
}, {
  label: 'Oman',
  value: 'OM',
  taxIds: [
    {
      type: 'om_vat',
      label: 'Omani VAT Number',
      placeholder: 'OM1234567890'
    }
  ],
  currency: 'OMR'
}, {
  label: 'Pakistan',
  value: 'PK',
  taxIds: [],
  currency: 'PKR'
}, {
  label: 'Palau',
  value: 'PW',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Palestine',
  value: 'PS',
  taxIds: [],
  currency: 'EGP'
}, {
  label: 'Panama',
  value: 'PA',
  taxIds: [],
  currency: 'PAB'
}, {
  label: 'Papua New Guinea',
  value: 'PG',
  taxIds: [],
  currency: 'PGK'
}, {
  label: 'Paraguay',
  value: 'PY',
  taxIds: [],
  currency: 'PYG'
}, {
  label: 'Peru',
  value: 'PE',
  taxIds: [
    {
      type: 'pe_ruc',
      label: 'Peruvian RUC number',
      placeholder: '12345678901'
    }
  ],
  currency: 'PEN'
}, {
  label: 'Philippines',
  value: 'PH',
  taxIds: [
    {
      type: 'ph_tin',
      label: 'Philippines Tax Identification Number',
      placeholder: '123456789012'
    }
  ],
  currency: 'PHP'
}, {
  label: 'Pitcairn',
  value: 'PN',
  taxIds: [],
  currency: 'NZD'
}, {
  label: 'Poland',
  value: 'PL',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'PL1234567890'
    }
  ],
  currency: 'PLN'
}, {
  label: 'Portugal',
  value: 'PT',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'PT123456789'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Puerto Rico',
  value: 'PR',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Qatar',
  value: 'QA',
  taxIds: [],
  currency: 'QAR'
}, {
  label: 'Republic of North Macedonia',
  value: 'MK',
  taxIds: [
    {
      type: 'mk_vat',
      label: 'North Macedonia VAT Number',
      placeholder: 'MK1234567890123'
    }
  ],
  currency: 'MKD'
}, {
  label: 'Romania',
  value: 'RO',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'RO1234567891'
    }
  ],
  currency: 'RON'
}, {
  label: 'Russia',
  value: 'RU',
  taxIds: [
    {
      type: 'ru_inn',
      label: 'Russian INN',
      placeholder: '1234567891'
    },
    {
      type: 'ru_kpp',
      label: 'Russian KPP',
      placeholder: '123456789'
    }
  ],
  currency: 'RUB'
}, {
  label: 'Rwanda',
  value: 'RW',
  taxIds: [],
  currency: 'RWF'
}, {
  label: 'Réunion',
  value: 'RE',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Saint Barthélemy',
  value: 'BL',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Saint Kitts and Nevis',
  value: 'KN',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Saint Lucia',
  value: 'LC',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Saint Martin',
  value: 'MF',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Saint Pierre and Miquelon',
  value: 'PM',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Saint Vincent and the Grenadines',
  value: 'VC',
  taxIds: [],
  currency: 'XCD'
}, {
  label: 'Samoa',
  value: 'WS',
  taxIds: [],
  currency: 'WST'
}, {
  label: 'San Marino',
  value: 'SM',
  taxIds: [],
  currency: 'EUR'
}, {
  label: 'Saudi Arabia',
  value: 'SA',
  taxIds: [
    {
      type: 'sa_vat',
      label: 'Saudi Arabia VAT',
      placeholder: '123456789012345'
    }
  ],
  currency: 'SAR'
}, {
  label: 'Senegal',
  value: 'SN',
  taxIds: [
    {
      type: 'sn_ninea',
      label: 'Senegal NINEA Number',
      placeholder: '12345672A2'
    }
  ],
  currency: 'XOF'
}, {
  label: 'Serbia',
  value: 'RS',
  taxIds: [
    {
      type: 'rs_pib',
      label: 'Serbian PIB number',
      placeholder: '123456789'
    }
  ],
  currency: 'RSD'
}, {
  label: 'Seychelles',
  value: 'SC',
  taxIds: [],
  currency: 'SCR'
}, {
  label: 'Sierra Leone',
  value: 'SL',
  taxIds: [],
  currency: 'SLE'
}, {
  label: 'Singapore',
  value: 'SG',
  taxIds: [
    {
      type: 'sg_gst',
      label: 'Singaporean GST',
      placeholder: 'M12345678X'
    },
    {
      type: 'sg_uen',
      label: 'Singaporean UEN',
      placeholder: '123456789F'
    }
  ],
  currency: 'SGD'
}, {
  label: 'Slovakia',
  value: 'SK',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'SK1234567891'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Slovenia',
  value: 'SI',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'SI12345678'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Solomon Islands',
  value: 'SB',
  taxIds: [],
  currency: 'SBD'
}, {
  label: 'Somalia',
  value: 'SO',
  taxIds: [],
  currency: 'SOS'
}, {
  label: 'South Africa',
  value: 'ZA',
  taxIds: [
    {
      type: 'za_vat',
      label: 'South African VAT number',
      placeholder: '4123456789'
    }
  ],
  currency: 'ZAR'
}, {
  label: 'South Sudan',
  value: 'SS',
  taxIds: [],
  currency: null
}, {
  label: 'Spain',
  value: 'ES',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'ESA1234567Z'
    }
  ],
  currency: 'EUR'
}, {
  label: 'Sri Lanka',
  value: 'LK',
  taxIds: [],
  currency: 'LKR'
}, {
  label: 'Sudan',
  value: 'SD',
  taxIds: [],
  currency: 'SDG'
}, {
  label: 'Suriname',
  value: 'SR',
  taxIds: [
    {
      type: 'sr_fin',
      label: 'Suriname FIN Number',
      placeholder: '1234567890'
    }
  ],
  currency: 'SRD'
}, {
  label: 'Sweden',
  value: 'SE',
  taxIds: [
    {
      type: 'eu_vat',
      label: 'European VAT number',
      placeholder: 'SE123456789123'
    }
  ],
  currency: 'SEK'
}, {
  label: 'Switzerland',
  value: 'CH',
  taxIds: [
    {
      type: 'ch_uid',
      label: 'Switzerland UID number',
      placeholder: 'CHE-123.456.789 HR'
    },
    {
      type: 'ch_vat',
      label: 'Switzerland VAT number',
      placeholder: 'CHE-123.456.789 MWST'
    }
  ],
  currency: 'CHF'
}, {
  label: 'Syrian Arab Republic',
  value: 'SY',
  taxIds: [],
  currency: 'SYP'
}, {
  label: 'Taiwan',
  value: 'TW',
  taxIds: [
    {
      type: 'tw_vat',
      label: 'Taiwanese VAT',
      placeholder: '12345678'
    }
  ],
  currency: 'TWD'
}, {
  label: 'Tajikistan',
  value: 'TJ',
  taxIds: [
    {
      type: 'tj_tin',
      label: 'Tajikistan Tax Identification Number',
      placeholder: '123456789'
    }
  ],
  currency: 'TJS'
}, {
  label: 'Tanzania',
  value: 'TZ',
  taxIds: [
    {
      type: 'tz_vat',
      label: 'Tanzania VAT Number',
      placeholder: '12345678A'
    }
  ],
  currency: 'TZS'
}, {
  label: 'Thailand',
  value: 'TH',
  taxIds: [
    {
      type: 'th_vat',
      label: 'Thai VAT',
      placeholder: '1234567891234'
    }
  ],
  currency: 'THB'
}, {
  label: 'Timor-Leste',
  value: 'TL',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Togo',
  value: 'TG',
  taxIds: [],
  currency: 'XOF'
}, {
  label: 'Tokelau',
  value: 'TK',
  taxIds: [],
  currency: 'NZD'
}, {
  label: 'Tonga',
  value: 'TO',
  taxIds: [],
  currency: 'TOP'
}, {
  label: 'Trinidad and Tobago',
  value: 'TT',
  taxIds: [],
  currency: 'TTD'
}, {
  label: 'Tunisia',
  value: 'TN',
  taxIds: [],
  currency: 'TND'
}, {
  label: 'Turkey',
  value: 'TR',
  taxIds: [
    {
      type: 'tr_tin',
      label: 'Turkish Tax Identification Number',
      placeholder: '0123456789'
    }
  ],
  currency: 'TRY'
}, {
  label: 'Turkmenistan',
  value: 'TM',
  taxIds: [],
  currency: 'TMT'
}, {
  label: 'Tuvalu',
  value: 'TV',
  taxIds: [],
  currency: 'AUD'
}, {
  label: 'Uganda',
  value: 'UG',
  taxIds: [
    {
      type: 'ug_tin',
      label: 'Uganda Tax Identification Number',
      placeholder: '1014751879'
    }
  ],
  currency: 'UGX'
}, {
  label: 'Ukraine',
  value: 'UA',
  taxIds: [
    {
      type: 'ua_vat',
      label: 'Ukrainian VAT',
      placeholder: '123456789'
    }
  ],
  currency: 'UAH'
}, {
  label: 'United Arab Emirates',
  value: 'AE',
  taxIds: [
    {
      type: 'ae_trn',
      label: 'United Arab Emirates TRN',
      placeholder: '123456789012345'
    }
  ],
  currency: 'AED'
}, {
  label: 'United Kingdom',
  value: 'GB',
  taxIds: [
    {
      type: 'gb_vat',
      label: 'United Kingdom VAT number',
      placeholder: 'GB123456789'
    }
  ],
  currency: 'GBP'
}, {
  label: 'United States of America',
  value: 'US',
  taxIds: [
    {
      type: 'us_ein',
      label: 'United States EIN',
      placeholder: '12-3456789'
    }
  ],
  currency: 'USD'
}, {
  label: 'Uruguay',
  value: 'UY',
  taxIds: [
    {
      type: 'uy_ruc',
      label: 'Uruguayan RUC number',
      placeholder: '123456789012'
    }
  ],
  currency: 'UYU'
}, {
  label: 'Uzbekistan',
  value: 'UZ',
  taxIds: [
    {
      type: 'uz_tin',
      label: 'Uzbekistan TIN Number',
      placeholder: '123456789'
    },
    {
      type: 'uz_vat',
      label: 'Uzbekistan VAT Number',
      placeholder: '123456789012'
    }
  ],
  currency: 'UZS'
}, {
  label: 'Vanuatu',
  value: 'VU',
  taxIds: [],
  currency: 'VUV'
}, {
  label: 'Venezuela',
  value: 'VE',
  taxIds: [
    {
      type: 've_rif',
      label: 'Venezuelan RIF number',
      placeholder: 'A-12345678-9'
    }
  ],
  currency: 'VES'
}, {
  label: 'Viet Nam',
  value: 'VN',
  taxIds: [
    {
      type: 'vn_tin',
      label: 'Vietnamese tax ID number',
      placeholder: '1234567890'
    }
  ],
  currency: 'VND'
}, {
  label: 'Virgin Islands (British)',
  value: 'VG',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Virgin Islands (U.S.)',
  value: 'VI',
  taxIds: [],
  currency: 'USD'
}, {
  label: 'Wallis and Futuna',
  value: 'WF',
  taxIds: [],
  currency: 'XPF'
}, {
  label: 'Western Sahara',
  value: 'EH',
  taxIds: [],
  currency: 'DZD'
}, {
  label: 'Yemen',
  value: 'YE',
  taxIds: [],
  currency: 'YER'
}, {
  label: 'Zambia',
  value: 'ZM',
  taxIds: [
    {
      type: 'zm_tin',
      label: 'Zambia Tax Identification Number',
      placeholder: '1004751879'
    }
  ],
  currency: 'ZMW'
}, {
  label: 'Zimbabwe',
  value: 'ZW',
  taxIds: [
    {
      type: 'zw_tin',
      label: 'Zimbabwe Tax Identification Number',
      placeholder: '1234567890'
    }
  ],
  currency: 'ZWL'
}];